import { motoBrandClient } from "../clients/motoBrandClient"
import type {
  MotoBrandResponseDto,
  CreateMotoBrandDto,
  UpdateMotoBrandDto,
  MotoBrandListParams,
  MotoBrandListResponseDto,
  DeleteMotoBrandResponseDto,
} from "../types/motoBrand.types"

/**
 * Moto Brand Service
 * Business logic layer - handles API responses, errors, and side effects
 */
export const motoBrandService = {
  /**
   * Get moto brand by ID
   */
  getMotoBrandById: async (id: string): Promise<MotoBrandResponseDto> => {
    try {
      const brand = await motoBrandClient.getMotoBrandById(id)
      return brand
    } catch (error: any) {
      throw error
    }
  },

  /**
   * List moto brands with filters
   */
  getMotoBrands: async (params?: MotoBrandListParams): Promise<MotoBrandListResponseDto> => {
    try {
      const response = await motoBrandClient.getMotoBrands(params)
      return response
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Create moto brand
   */
  createMotoBrand: async (data: CreateMotoBrandDto): Promise<MotoBrandResponseDto> => {
    try {
      const brand = await motoBrandClient.createMotoBrand(data)
      return brand
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Update moto brand
   */
  updateMotoBrand: async (
    id: string,
    data: UpdateMotoBrandDto
  ): Promise<MotoBrandResponseDto> => {
    try {
      const brand = await motoBrandClient.updateMotoBrand(id, data)
      return brand
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Delete moto brand
   */
  deleteMotoBrand: async (id: string): Promise<DeleteMotoBrandResponseDto> => {
    try {
      const response = await motoBrandClient.deleteMotoBrand(id)
      return response
    } catch (error: any) {
      throw error
    }
  },
}

export default motoBrandService

